import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { Paper, Tab } from '@mui/material';
import React, { SyntheticEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import useLocales from 'src/hooks/useLocales';
import { useAppSelector } from 'src/redux/store';
import { tabStyles } from 'src/utils/tabStyles';
import { EnqueteConfirmTab } from '../../shared-tabs/answer-confirm-status/components/EnqueteConfirmTab';
import OutsideSurveyPeriodTypography from '../../shared-tabs/outside-survey/components/OutsideSurveyPeriodTypography';
import { EnqueteAnswerOverviewTab } from './tabs/answer/components/EnqueteAnswerOverviewTab';
import ChangeRespondentComponent from '../../shared-tabs/change-respondent/components/ChangeRespondentComponent';

const TAB_VALUE = {
  QUESTION: 'overviewQuestion',
  CONFIRM: 'EnqueteStatus',
  CHANGE: 'ChangeRespondents',
} as const;
type TabValue = typeof TAB_VALUE[keyof typeof TAB_VALUE];

export const EnqueteAnswerTypeOverviewTabContainer: React.FC = () => {
  const respondentTargetData = useAppSelector((state) => state.enqueteAnswer.respondentTargetData);
  const respondentRequestData = useAppSelector((state) => state.enqueteAnswer.respondentRequestData);
  // 依頼期間前かの情報を格納
  const isBeforeRequestTerm = useAppSelector((state) => state.enqueteAnswer.isBeforeRequestTerm);
  const isAfterRequestTerm = useAppSelector((state) => state.enqueteAnswer.isAfterRequestTerm);
  const { t } = useTranslation();
  const { currentLang } = useLocales();
  // タブ切り替え
  const handleChange = (_event: SyntheticEvent, newValue: TabValue) => {
    setTabValue(newValue);
  };
  const params = useLocation().search;
  // URLに含まれるTabパラメータを取得
  const tabParmsValue = new URLSearchParams(params).get('tab');
  const defaultTab = tabParmsValue ? tabParmsValue : TAB_VALUE.QUESTION;
  const [tabValue, setTabValue] = useState<TabValue>(defaultTab as TabValue);

  return (
    <TabContext value={tabValue}>
      <Paper variant="elevation">
        <TabList onChange={handleChange}>
          <Tab
            style={tabStyles(currentLang.value)}
            label={t('enqueteAnswerInput.tab.surveyTypeOverview')}
            value={TAB_VALUE.QUESTION}
            sx={{ paddingLeft: 2 }}
            disabled={isBeforeRequestTerm}
          />
          <Tab
            style={tabStyles(currentLang.value)}
            label={t('enqueteAnswerInput.tab.responseConfirmationStatus')}
            value={TAB_VALUE.CONFIRM}
            disabled={isBeforeRequestTerm}
          />
          <Tab
            style={tabStyles(currentLang.value)}
            label={t('enqueteAnswerInput.tab.changeRespondents')}
            value={TAB_VALUE.CHANGE}
            disabled={isAfterRequestTerm}
          />
        </TabList>
        {/** アンケートコンポーネント */}
        <TabPanel value={TAB_VALUE.QUESTION}>
          {isBeforeRequestTerm ? <OutsideSurveyPeriodTypography requestStatus={'before'} /> : <EnqueteAnswerOverviewTab />}
        </TabPanel>
        {/** 回答確認状況コンポーネント */}
        <TabPanel value={TAB_VALUE.CONFIRM}>
          {isBeforeRequestTerm ? <OutsideSurveyPeriodTypography requestStatus={'before'} /> : <EnqueteConfirmTab />}
        </TabPanel>
        <TabPanel value={TAB_VALUE.CHANGE}>
          {isAfterRequestTerm ? (
            <OutsideSurveyPeriodTypography requestStatus={'after'} />
          ) : (
            <ChangeRespondentComponent
              respondentRequestId={respondentRequestData.id}
              respondentTargetId={respondentTargetData.id}
              organizationId={respondentTargetData.organizationId}
            />
          )}
        </TabPanel>
      </Paper>
    </TabContext>
  );
};
